import { h } from "preact";

interface MiniCartHeaderProps {
  closeDrawer: () => void;
}

function MiniCartHeader({ closeDrawer }: MiniCartHeaderProps) {
  return (
    <div className="minicart__header">
      <p
        className="
        minicart__header-title
        heading-3
      "
      >
        {window.themeVars.strings.cart.basket}
      </p>

      <button
        className="minicart__close"
        aria-label={window.themeVars.strings.cart.cartClose}
        type="button"
        onClick={closeDrawer}
      >
        <span
          className="minicart__close-icon"
          dangerouslySetInnerHTML={{ __html: window.themeVars.icons.close }}
        ></span>
      </button>
    </div>
  );
}

export default MiniCartHeader;
